export default "__VITE_ASSET__Cvb7TBMv__"